import { render, staticRenderFns } from "./IndexAdmin.vue?vue&type=template&id=2f44849b&"
import script from "./IndexAdmin.vue?vue&type=script&lang=js&"
export * from "./IndexAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports